exports = module.exports = require("../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".react-autosuggest__suggestions-list,\n.react-autosuggest__suggestion {\n  list-style-type: none;\n  margin: 0;\n  padding: 0; }\n\n.autosuggest-item {\n  background: #FAFAFA;\n  cursor: pointer;\n  padding: 1rem; }\n\n.react-autosuggest__suggestion--focused > .autosuggest-item {\n  background: #FFFFFF; }\n\n.react-autosuggest__input {\n  background: white;\n  border: 1px solid #68B4FF !important;\n  border-radius: 3px;\n  box-sizing: border-box;\n  color: black;\n  line-height: 1rem;\n  margin: 0;\n  margin-bottom: 0;\n  outline-width: 0;\n  padding: 0.25rem 0.5rem;\n  width: 100%; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader!./node_modules/react-autosuggest-geocoder/src/styles/index.scss
// module id = 300
// module chunks = 0